
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeave as ObiHeaveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heave.js';
 
 
 

 
 export const ObiHeave = createComponent({
   react: React,
   tagName: 'obi-heave',
   elementClass: ObiHeaveElement,
   events: {
     
   }
  });
 
 